"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreviewPanelPagination = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const ramda_1 = require("ramda");
const styled_components_1 = require("styled-components");
const pagination_styles_1 = require("./pagination.styles");
const client_constants_1 = require("../../../client/client.constants");
const pagination_utils_1 = require("../../../../generic/pagination/pagination.utils");
const localization_1 = require("../../../../localization");
const MAX_PAGES_DISPLAY = 10;
const PreviewPanelPagination = ({ itemsCount, pageNumber, pageSize, onPageChange, onPageSizeChange, }) => {
    var _a;
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const { palette } = (0, styled_components_1.useTheme)();
    const { pagesCount, startRange, endRange } = (0, pagination_utils_1.getPaginationValues)({ itemsCount, pageNumber, pageSize });
    const [anchor, setAnchor] = (0, react_1.useState)(null);
    const isValidPageNumber = pageNumber > 0 && pageNumber <= pagesCount;
    const getArrowColor = (canClick) => (canClick ? ui_components_1.baseColors.primaryGreen500 : ui_components_1.baseColors.primaryBlueMed200);
    const handleCloseMenu = () => {
        setAnchor(null);
    };
    const updatePage = (pageNumber) => {
        const pageNumberValue = Number(pageNumber);
        if (pageNumberValue > 0) {
            onPageChange(pageNumberValue);
        }
    };
    const handleChange = (pageNumber) => () => {
        handleCloseMenu();
        updatePage(pageNumber);
    };
    const pageNumbers = pageNumber <= MAX_PAGES_DISPLAY || !isValidPageNumber
        ? (0, ramda_1.range)(1, Math.min(MAX_PAGES_DISPLAY + 1, pagesCount + 1))
        : pageNumber > (pagesCount - MAX_PAGES_DISPLAY)
            ? (0, ramda_1.range)(pagesCount - MAX_PAGES_DISPLAY + 1, pagesCount + 1)
            : (_a = (0, ramda_1.range)(pageNumber - (MAX_PAGES_DISPLAY / 2), Math.min(pageNumber + (MAX_PAGES_DISPLAY / 2), pagesCount + 1))) !== null && _a !== void 0 ? _a : null;
    const canClickPreviousPage = pageNumber - 1 >= 1;
    const handlePreviousPageClick = () => {
        if (!canClickPreviousPage)
            return;
        updatePage(pageNumber - 1);
    };
    const canClickNextPage = pageNumber + 1 <= pagesCount;
    const handleNextPageClick = () => {
        if (!canClickNextPage)
            return;
        updatePage(pageNumber + 1);
    };
    const handlePageSizeChange = (e) => onPageSizeChange(Number(e.target.value));
    const paginationCurrentRangeLabel = t({
        key: 'PAGINATION_CURRENT_RANGE_LABEL',
        values: {
            startRange,
            endRange,
            total: itemsCount,
            type: t({ key: 'PRODUCTS' }),
        },
    });
    const renderMenu = pageNumbers && (react_1.default.createElement(ui_components_1.MenuList, { anchorEl: anchor, anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
        }, transformOrigin: {
            vertical: 'top',
            horizontal: 'right',
        }, keepMounted: true, open: Boolean(anchor), onClose: handleCloseMenu }, pageNumbers.map((pageNum) => (react_1.default.createElement(ui_components_1.MenuItem, { key: pageNum, value: pageNum, onClick: handleChange(pageNum) }, pageNum)))));
    const options = (0, react_1.useMemo)(() => client_constants_1.PAGE_SIZES.map((key) => (react_1.default.createElement(ui_components_1.MenuItem, { key: key, value: key }, key))), []);
    return (react_1.default.createElement(pagination_styles_1.StyledPaginationWrapper, null, renderMenu, react_1.default.createElement(pagination_styles_1.StyledPageSelectorWrapper, null, react_1.default.createElement(ui_components_1.Typography, { color: "textSecondary" }, `${t({ key: 'REF_APP_PAGINATION_PER_PAGE' })}:`), react_1.default.createElement(pagination_styles_1.StyledPageSizeSelect, { variant: "outlined", renderValue: (value) => (typeof value === 'string' || typeof value === 'number' ? `${value}` : ''), value: String(pageSize), onChange: handlePageSizeChange, IconComponent: (iconComponentProps) => (react_1.default.createElement(pagination_styles_1.StyledIcon, Object.assign({ variant: "chevronDown", color: palette.primary.main }, iconComponentProps))) }, options), react_1.default.createElement(pagination_styles_1.StyledDivider, null), react_1.default.createElement(ui_components_1.Typography, { variant: "body2", color: "textSecondary" }, isValidPageNumber && (paginationCurrentRangeLabel || `${startRange} - ${endRange}`))), react_1.default.createElement(pagination_styles_1.StyledFlexWrapper, null, react_1.default.createElement(pagination_styles_1.StyledPageSelectorWrapper, null, react_1.default.createElement(pagination_styles_1.StyledPaginationCount, { variant: "body2", color: "textSecondary" }, pageNumber, "\u00A0", t({ key: 'PAGINATION_COUNT_LABEL', values: { numPages: pagesCount } }))), react_1.default.createElement(pagination_styles_1.StyledDivider, null), react_1.default.createElement(pagination_styles_1.StyledFlexWrapper, null, react_1.default.createElement(ui_components_1.Icon, { variant: "arrowPaginationPrevious", showHover: canClickPreviousPage, color: getArrowColor(canClickPreviousPage), disabled: !canClickPreviousPage, onClick: handlePreviousPageClick }), react_1.default.createElement(ui_components_1.Icon, { variant: "arrowPaginationNext", showHover: canClickNextPage, color: getArrowColor(canClickNextPage), disabled: !canClickNextPage, onClick: handleNextPageClick })))));
};
exports.PreviewPanelPagination = PreviewPanelPagination;
